import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { unreachableWithReturn } from './utils';
export const getErrorMessage = errorType => {
  switch (errorType) {
    case 'rate-limit-error':
      return 'You have reached your hourly message limit. Wait a bit to be able to chat again.';
    case 'gpt-stream-error':
      return 'OpenAI is not available at the moment. Wait a bit to be able to chat again.';
    case 'unknown-error':
      return 'Something went wrong, please try again later.';
    default:
      return unreachableWithReturn(errorType, '');
  }
};
export function appendToOrOverwriteLastMessage(_ref) {
  var _updatedMessages;
  let {
    message,
    partialContent,
    previousConversation
  } = _ref;
  const updatedMessages = [...previousConversation.messages];
  const shouldAppendToLastMessage = ((_updatedMessages = updatedMessages[updatedMessages.length - 1]) === null || _updatedMessages === void 0 ? void 0 : _updatedMessages.role) === 'assistant';
  if (shouldAppendToLastMessage) {
    updatedMessages[updatedMessages.length - 1] = _objectSpread(_objectSpread({}, message), {}, {
      content: partialContent
    });
  } else {
    updatedMessages.push(_objectSpread(_objectSpread({}, message), {}, {
      content: partialContent
    }));
  }
  return _objectSpread(_objectSpread({}, previousConversation), {}, {
    messages: updatedMessages
  });
}
export function getRandomConversationIndex(_ref2) {
  let {
    amountOfSolutionConversations,
    lastSolutionConversationIndex
  } = _ref2;
  if (amountOfSolutionConversations === 1) {
    return 0;
  }
  const allowedIndices = Array.from({
    length: amountOfSolutionConversations
  }, (_, index) => index).filter(index => index !== lastSolutionConversationIndex);
  return allowedIndices[Math.floor(Math.random() * allowedIndices.length)];
}